import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { inject, observer } from 'mobx-react';
import { css } from '@emotion/core';
import { Form } from 'antd';
import styled from '@emotion/styled';
import CustomInput from '../../common/Input';
import { SettingsFormHeader } from '../../common/SettingsFormHeader';
import Dropdown from '../../common/Dropdown';
import ChangePassword from '../../ChangePassword';
import CurrencyDropdown from '../../CurrencyDropdown';
import CountriesDropdown from '../../common/CountriesDropdown';
import {
  nameToUpperTwo,
  upperThreeToTwo,
  upperTwoToName,
  upperTwoToThree,
} from '../../../constants/countries';
import { text3 } from '../../../constants/classes';
import ENUMS from '../../../constants/enums';
// import { ServiceAgreement } from '../../ServiceAgreement';
// import { ServiceAgreementAffiliate } from '../../ServiceAgreementAffiliate';

const { Option } = Dropdown;
// const { info } = Modal;

const FormItem = styled(Form.Item)`
  margin: 5px;
  & label {
    font-weight: 400 !important;
  }
`;
// & > .ant-form-item-label {
//   ${({required})=> required? `
//     & > .ant-form-item-label:before {
//       display: inline-block;
//       margin-right: 4px;
//       content: "*";
//       font-family: SimSun;
//       line-height: 1;
//       font-size: 12px;
//       color: #f5222d;
//     }` : ''
//   }
// }

@injectIntl
@Form.create()
@inject('settingsStore')
@observer
class UserProfile extends Component {
  componentDidMount() {
    const {
      settingsStore: { setActiveTab },
    } = this.props;
    setActiveTab(ENUMS.SETTINGS_TABS.USER_PROFILE);
    this.props.updateBreadcrumbs(
      {
        name: this.props.intl.formatMessage({ id: 'settingsModal.userProfile' }),
      },
      true,
    );
  }

  // componentWillUnmount() {
  //   const {preventTabChange, form: {validateFields}, settingsStore: {subscription: {currentPlanId}}} = this.props;
  //   validateFields(err => {
  //     if (err && currentPlanId && (currentPlanId !== 'free')) {
  //       preventTabChange();
  //     }
  //   });
  // }

  connectToSaveButton = inputHandler => inputValue => {
    inputHandler(inputValue.target ? inputValue.target.value : inputValue);
    const { updateApplyBtn } = this.props;
    updateApplyBtn();
  };

  renderFormItem = ({ key, intlKey, rules, inputType, onChange, disabled }) => {
    const { intl, form, userProfile } = this.props;
    const { getFieldDecorator } = form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    return (
      <FormItem {...formItemLayout} label={intl.formatMessage({ id: `userProfile.${intlKey}` })}>
        {getFieldDecorator(key, {
          initialValue: userProfile[key],
          rules,
        })(<CustomInput type={inputType} onChange={onChange} disabled={disabled} />)}
      </FormItem>
    );
  };

  render() {
    const { intl, form, userProfile } = this.props;
    const { getFieldDecorator } = form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    return (
      <Form className="login-form" layout="vertical">
        <SettingsFormHeader
          marginTop="0em"
          id="userProfile.loginInformation"
          defaultMessage="LOGIN INFORMATION"
        />
        {this.renderFormItem({
          key: 'email',
          intlKey: 'userName',
          rules: [
            {
              required: true,
            },
            {
              type: 'email',
              message: intl.formatMessage({ id: 'userProfile.invalidNotEmail' }),
            },
          ],
          inputType: 'text',
          onChange: e => userProfile.setEmail(e.target.value),
          disabled: true,
        })}
        <ChangePassword userName={userProfile.email} />
        <SettingsFormHeader
          id="userProfile.interfaceSettings"
          defaultMessage="INTERFACE SETTINGS"
        />

        <FormItem {...formItemLayout} label="Language">
          {getFieldDecorator('languageId', {
            initialValue: userProfile.languageId,
            rules: [{ required: true, message: 'Please select your language!' }],
          })(
            <Dropdown onChange={this.connectToSaveButton(userProfile.setLanguageId)} width="150px">
              <Option value="en">
                <FormattedMessage id="userProfile.englishUSA" defaultMessage="English (USA)" />
              </Option>
              <Option value="es">
                <FormattedMessage id="userProfile.spanish" defaultMessage="Española" />
              </Option>
              <Option value="bg">
                <FormattedMessage id="userProfile.bulgarian" defaultMessage="Български" />
              </Option>
              <Option value="it">
                <FormattedMessage id="userProfile.italian" defaultMessage="Italiana" />
              </Option>
              <Option value="pt">
                <FormattedMessage id="userProfile.portuguese" defaultMessage="Português" />
              </Option>
              <Option value="de">
                <FormattedMessage id="userProfile.german" defaultMessage="Deutsche" />
              </Option>
              <Option value="el">
                <FormattedMessage id="userProfile.greek" defaultMessage="Ελληνικά" />
              </Option>
              <Option value="ja">
                <FormattedMessage id="userProfile.japanese" defaultMessage="日本語" />
              </Option>
              <Option value="he">
                <FormattedMessage id="userProfile.hebrew" defaultMessage="עברית" />
              </Option>
              <Option value="ar">
                <FormattedMessage id="userProfile.arabic" defaultMessage="עברית" />
              </Option>
              <Option value="fr">
                <FormattedMessage id="userProfile.french" defaultMessage="עברית" />
              </Option>
              <Option value="hi">
                <FormattedMessage id="userProfile.hindi" defaultMessage="עברית" />
              </Option>
              <Option value="fil">
                <FormattedMessage id="userProfile.filipino" defaultMessage="עברית" />
              </Option>
              <Option value="ro">
                <FormattedMessage id="userProfile.romanian" defaultMessage="עברית" />
              </Option>
              <Option value="th">
                <FormattedMessage id="userProfile.thai" defaultMessage="עברית" />
              </Option>
              <Option value="vi">
                <FormattedMessage id="userProfile.vietnamese" defaultMessage="עברית" />
              </Option>
            </Dropdown>,
          )}
        </FormItem>
        <FormItem {...formItemLayout} label="Default Currency">
          <CurrencyDropdown
            defaultValue={userProfile.defaultCurrencyId}
            onChange={this.connectToSaveButton(userProfile.setDefaultCurrencyId)}
            small
            isBetaUser={userProfile.isBetaUser}
          />
        </FormItem>
        <SettingsFormHeader
          id="userProfile.businessInformation"
          defaultMessage="BUSINESS INFORMATION"
        />
        <FormItem
          {...formItemLayout}
          label={intl.formatMessage({ id: 'userProfile.businessName' })}
        >
          {getFieldDecorator('businessName', {
            initialValue: userProfile.businessName,
            rules: [
              {
                required: false,
              },
              { max: 70 },
              {
                type: 'string',
                message: intl.formatMessage({ id: 'userProfile.invalidNotString' }),
              },
            ],
          })(
            <CustomInput
              type="text"
              onChange={this.connectToSaveButton(userProfile.setBusinessName)}
            />,
          )}
        </FormItem>
        <FormItem {...formItemLayout} label={intl.formatMessage({ id: 'userProfile.firstName' })}>
          {getFieldDecorator('firstName', {
            initialValue: userProfile.firstName,
            rules: [
              {
                required: true,
                message: intl.formatMessage({ id: 'userProfile.firstName_prompt' }),
              },
              { min: 2 },
              { max: 40 },
              {
                type: 'string',
                message: intl.formatMessage({ id: 'userProfile.invalidNotString' }),
              },
            ],
          })(
            <CustomInput
              type="text"
              onChange={this.connectToSaveButton(userProfile.setFirstName)}
            />,
          )}
        </FormItem>
        <FormItem {...formItemLayout} label={intl.formatMessage({ id: 'userProfile.lastName' })}>
          {getFieldDecorator('lastName', {
            initialValue: userProfile.lastName,
            rules: [
              {
                required: true,
                message: intl.formatMessage({ id: 'userProfile.lastName_prompt' }),
              },
              { max: 40 },
              {
                type: 'string',
                message: intl.formatMessage({ id: 'userProfile.invalidNotString' }),
              },
            ],
          })(
            <CustomInput
              type="text"
              onChange={this.connectToSaveButton(userProfile.setLastName)}
            />,
          )}
        </FormItem>
        <FormItem {...formItemLayout} label={intl.formatMessage({ id: 'userProfile.street' })}>
          {getFieldDecorator('street', {
            initialValue: userProfile.street,
            rules: [
              {
                required: false,
              },
              { max: 100 },
              {
                type: 'string',
                message: intl.formatMessage({ id: 'userProfile.invalidNotString' }),
              },
            ],
          })(
            <CustomInput type="text" onChange={this.connectToSaveButton(userProfile.setStreet)} />,
          )}
        </FormItem>
        <FormItem {...formItemLayout} label={intl.formatMessage({ id: 'userProfile.city' })}>
          {getFieldDecorator('city', {
            initialValue: userProfile.city,
            rules: [
              {
                required: false,
              },
              { max: 40 },
              {
                type: 'string',
                message: intl.formatMessage({ id: 'userProfile.invalidNotString' }),
              },
            ],
          })(<CustomInput type="text" onChange={this.connectToSaveButton(userProfile.setCity)} />)}
        </FormItem>
        <FormItem {...formItemLayout} label={intl.formatMessage({ id: 'userProfile.state' })}>
          {getFieldDecorator('state', {
            initialValue: userProfile.state,
            rules: [
              {
                required: false,
              },
              { max: 40 },
              {
                type: 'string',
                message: intl.formatMessage({ id: 'userProfile.invalidNotString' }),
              },
            ],
          })(<CustomInput type="text" onChange={this.connectToSaveButton(userProfile.setState)} />)}
        </FormItem>
        <FormItem {...formItemLayout} label={intl.formatMessage({ id: 'userProfile.zipcode' })}>
          {getFieldDecorator('zipcode', {
            initialValue: userProfile.zipcode,
            rules: [
              {
                required: false,
              },
              { max: 10 },
              {
                pattern: /^\d+$/,
                message: intl.formatMessage({ id: 'userProfile.invalidNotNumber' }),
              },
            ],
          })(
            <CustomInput
              type="string"
              onChange={this.connectToSaveButton(userProfile.setZipcode)}
            />,
          )}
        </FormItem>
        <FormItem {...formItemLayout} label={intl.formatMessage({ id: 'common.country' })}>
          {getFieldDecorator('country', {
            initialValue: nameToUpperTwo[userProfile.country]
              ? upperTwoToThree[nameToUpperTwo[userProfile.country]]
              : '',
            rules: [
              {
                required: true,
              },
            ],
          })(
            <CountriesDropdown
              fullWidth
              onChange={country =>
                this.connectToSaveButton(userProfile.setCountry)(
                  upperTwoToName[upperThreeToTwo[country]],
                )
              }
              width="15.7em"
              countryFormat="full"
            />,
          )}
        </FormItem>
        <FormItem {...formItemLayout} label={intl.formatMessage({ id: 'userProfile.phoneNumber' })}>
          {getFieldDecorator('phoneNumber', {
            initialValue: userProfile.phoneNumber,
            rules: [
              {
                required: true,
                message: intl.formatMessage({ id: 'userProfile.phoneNumber_prompt' }),
              },
              { max: 15 },
              {
                pattern: /^\d+$/,
                message: intl.formatMessage({ id: 'userProfile.invalidNotNumber' }),
              },
            ],
          })(
            <CustomInput
              type="tel"
              onChange={this.connectToSaveButton(userProfile.setPhoneNumber)}
            />,
          )}
        </FormItem>
        <span
          css={css`
            ${text3};
          `}
        >
          {`${intl.formatMessage({ id: 'userProfile.bySigningUp' })} `}
          <a
            // onClick={() =>
            //   info({
            //     width: '650px',
            //     content: (
            //       <div
            //         css={css`
            //           width: 550px;
            //           height: 40vh;
            //           overflow-y: scroll;
            //           margin-bottom: 10px;
            //         `}
            //       >
            //         <ServiceAgreement />
            //       </div>
            //     ),
            //   })
            // }
            // css={css`
            //   text-decoration: underline;
            // `}
            rel="noopener noreferrer"
            target="_blank"
            href="https://www.triplemars.com/saas-service-agreement/"
            css={css`
              text-decoration: underline;
            `}
          >
            {intl.formatMessage({ id: 'userProfile.termsOfUse' })}
          </a>
          &nbsp;|&nbsp;
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="http://www.triplemars.com/privacy"
            css={css`
              text-decoration: underline;
            `}
          >
            {intl.formatMessage({ id: 'userProfile.privacyPolicy' })}
          </a>
        </span>
        {/* <SettingsFormHeader id="userProfile.affiliateProgram" defaultMessage="AFFILIATE PROGRAM" /> */}
        {/* <span
          css={css`
            ${text3};
          `}
        >
          <a
            rel="noopener noreferrer"
            target="_blank"
            href={`https://app.leaddyno.com/provision?email=${encodeURIComponent(
              userProfile.email,
            )}&key=${window.LeadDyno.key}`}
            css={css`
              text-decoration: underline;
            `}
          >
            Click Here To Join Our Affiliate Program
          </a>
          <br />
          {`${intl.formatMessage({ id: 'userProfile.bySigningUpAffiliate' })} `}
          <a
            onClick={() =>
              info({
                width: '650px',
                content: (
                  <div
                    css={css`
                      width: 550px;
                      height: 40vh;
                      overflow-y: scroll;
                      margin-bottom: 10px;
                    `}
                  >
                    <ServiceAgreementAffiliate />
                  </div>
                ),
              })
            }
            css={css`
              text-decoration: underline;
            `}
          >
            {intl.formatMessage({ id: 'userProfile.termsOfUse' })}
          </a>
        </span> */}
      </Form>
    );
  }
}

UserProfile.propTypes = {
  intl: PropTypes.object,
  form: PropTypes.object,
  userProfile: PropTypes.object,
  updateBreadcrumbs: PropTypes.func,
  // preventTabChange: PropTypes.func,
  updateApplyBtn: PropTypes.func,
  settingsStore: PropTypes.object,
};

export default UserProfile;
